// extracted by mini-css-extract-plugin
export var copyableItem = "_4d-0";
export var underlined = "_4d-1";